import _isNil from "lodash/isNil";

const removeEmptyEntries = (array: Array<any>) => {
    return array?.filter(x => !_isNil(x) && x.length > 0);
}

export default removeEmptyEntries;
